export default "__VITE_ASSET__B3I9fk2t__"